import React from 'react';
import loginBackground from '../../../../assets/images/login-background.png';
import vamosLogo from '../../../../assets/images/vamos-horizontal-logo.png';
import HypertextLink from '../../componentsV2/HypertextLink/HypertextLink';
import { ToastProvider } from '../../providers/ToastProvider';
import Icon from '../../componentsV2/Icons/Icon';
import PageFooter from '../../componentsV2/PageFooter/PageFooter';

const ResetPasswordSuccessPage = () => {
  return (
    <ToastProvider>
      <div
        className="min-h-screen w-screen bg-no-repeat bg-top-0 overflow-y-auto flex flex-col justify-between"
        style={{ backgroundImage: `url(${loginBackground})` }}
      >
        <div className="flex flex-col items-end">
          <div className="flex flex-col items-center justify-center w-full md:w-3/4 xl:w-1/3 mr-0 md:mr-47 mx-auto mb-8">
            <img
              src={vamosLogo}
              alt="Vamos horizontal logo"
              className="w-100 h-36.5 flex-shrink-0"
            />
            <div className="w-full max-w-101 h-auto mt-12.75 flex-shrink-0">
              <div className="bg-vamos-green2-opacity-50 shadow-vamos-drop-shadow rounded-md py-9 px-20 text-center text-vamos-black text-base font-medium shadow-md">
                <span className="inline-flex items-center justify-center text-vamos-black text-center font-sans font-bold leading-normal text-24"><Icon name="mail" className="mr-2" />Check your inbox</span>
                <p className="mt-4.5 inline-flex items-center text-left font-normal">
                  You will receive an email with instructions on how to reset your password in a few minutes.
                  <br />
                  Check your spam box as well.
                </p>
              </div>

              <div className="text-center mt-4.25">
                <HypertextLink href="/users/sign_in">
                  Back to Login
                </HypertextLink>
              </div>
            </div>
          </div>
        </div>
        <PageFooter />
      </div>
    </ToastProvider>
  );
};

export default ResetPasswordSuccessPage;
